import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoAlcancesProyectoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoAlcancesProyectoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCatalogoAlcancesProyectoService(): Observable<BodyListResponse<CatalogoAlcancesProyectoDTO>> {
    return this.http.get<BodyListResponse<CatalogoAlcancesProyectoDTO>>(API_URL + '/api/v1/catalogoAlcancesProyecto/todos');
  }

  guardarCatalogoAlcancesProyectoService(catalogoAlcancesProyectoDTO: CatalogoAlcancesProyectoDTO): Observable<BodyResponse<CatalogoAlcancesProyectoDTO>> {
    return this.http.post<BodyResponse<CatalogoAlcancesProyectoDTO>>(API_URL + '/api/v1/catalogoAlcancesProyecto', catalogoAlcancesProyectoDTO);
  }

  getCatalogoAlcancesProyectoPorCodigoCatalogoAlcanceProyectoService(codigoCatalogoAlcanceProyecto: string): Observable<BodyResponse<CatalogoAlcancesProyectoDTO>> {
    return this.http.get<BodyResponse<CatalogoAlcancesProyectoDTO>>(API_URL + '/api/v1/catalogoAlcancesProyecto/' + codigoCatalogoAlcanceProyecto);
  }
}
